module.exports = __webpack_public_path__ + "img/VirtualBiometric.3afae0c0.svg";